import React, { useState } from 'react';
import { validateBudgetForm} from '../../../modules/settings/settings';
import { DropdownComponent, InputComponent } from '../../core/Forms';
import { updateBudget} from '../../../backend-services';
import ProcessSuccessful from '../../../assets/icons/ProcessSuccessful';
import { Button, SidebarDrawer } from '../../common';
import { ICreateBudget } from '../../../@types';
import { clearFieldError, handleErrors } from '../../../utils/handleErrors';
import { ViewBudget } from './view';

interface EditPaymentCredentialsProps {
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  isLoading: boolean;
   monthYear: string;
   allocatedBudget: any;
budgetData?: ICreateBudget;
}
export const EditBudget: React.FC<EditPaymentCredentialsProps> = ({
budgetData,
  onSubmit, 
}) => {
  const [showSuccessModal, setShowSuccessModal] = React.useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const [selectedValue, setSelectedValue] = React.useState('');
  const [isSubmitted, setIsSubmitted] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [, setErrorMessage] = React.useState<string>('');
  const [showBudget, setShowBudget] = React.useState(false);
  
  const [formData, setFormData] = useState<ICreateBudget>({
    monthYear: '',
    allocatedBudget: null,
    });

    const [validationResults, setValidationResults] = React.useState({
        monthYear: '',
        allocatedBudget: null,
    });

    const addCommasToNumber = (value: any) => {
      if (value === null) {
        return ''; 
      }
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const { name, value } = event.target;
        setFormData({
          ...formData,
          [name]: value,
        });
        clearFieldError(name, validationResults, setValidationResults);
      };

      const handleSubmit = async (event?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        event?.preventDefault();
      
    
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth() + 1;
        const currentYear = currentDate.getFullYear();
      
        const [month, year] = formData.monthYear.split('-').map(Number);
      
        if (month === currentMonth && year === currentYear) {
          setIsLoading(true);
          try {
            const updatedData = {
              monthYear: formData.monthYear,
              allocatedBudget: Number(formData.allocatedBudget),
            };
            await updateBudget(updatedData);
            setShowBudget(true);
      
            setShowSuccessModal(true);
            setShowDrawer(true);
            setFormData((prevState) => ({
              ...prevState,
              allocatedBudget: updatedData.allocatedBudget,
              monthYear: updatedData.monthYear,
            }));
          } catch (error) {
            console.log(error);
            handleErrors(error, setErrorMessage,);
          } finally {
            setIsLoading(false);
            setIsSubmitted(true);

          }
        } else {
          setErrorMessage('Updates are only allowed for the current month.');
        }
      };

    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;
    const getMonthLabel = (month: number) => {
      const options = { month: 'long' } as Intl.DateTimeFormatOptions;
      const date = new Date(currentYear, month - 1, 1);
      return date.toLocaleDateString('en-NG', options);
    };
  
    const dropDownArray = [];
  
    for (let month = currentMonth; month <= 12; month++) {
      dropDownArray.push({
        value: `${month.toString().padStart(2, '0')}-${currentYear}`,
        label: getMonthLabel(month),
      });
    }
  
    for (let year = currentYear + 1; year <= currentYear + 0; year++) {
      for (let month = 1; month <= 12; month++) {
        dropDownArray.push({
          value: `${month.toString().padStart(2, '0')}-${year}`,
          label: getMonthLabel(month),
        });
      }
    }
  
    const handleDropDownChange = (name: string, selectedValue: string) => {
      const [month, year] = selectedValue.split('-');
      const formattedValue = `${month.padStart(2, '0')}-${year}`;
  
      setFormData({ ...formData, monthYear: formattedValue });
      clearFieldError(name, validationResults, setValidationResults);
    };


    const handleContinue = () => {
        setShowSuccessModal(false);
        setShowBudget(true);
      };

      const isBudgetSet = formData.monthYear && formData.allocatedBudget;
    return (
      <div>
       <form onSubmit={(event) => event.preventDefault()}>
       {showBudget ? (
          <ViewBudget monthYear={formData.monthYear} allocatedBudget={formData.allocatedBudget} 
            />
        ) : (
            <div className=''>
              {!showBudget && (
                <div className="bg-[#FFFFFF] flex flex-col justify-center lg:justify-start items-center lg:items-start  sm:w-full  lg:ml-[-1em] lg:h-screen mt-[-1.4em]  md:mt-[-0.4em] lg:mt-[-0.1em] ">
                <h1 className="text-[16px] lg:text-[20px] text font-semibold lg:font-semibold pt-[20px] pl-[10px] lg:pl-[64px] md:pl-[24px] lg:pt-[55px]">Expense Budget</h1>
                <p className=" font-sm lg:text-[16px] text-[12px] lg:font-sm pl-[20px] lg:pl-[64px] md:pl-[24px] lg:pt-[7px] pb-[10px] md:pb-[24px]">
                  Set a monthly budget for your expenses.
                </p>
                <hr className=" lg:mt-[1em] lg:w-full" />
                <div className="w-[310px] sm:w-auto md:flex lg:flex md:flex-col md:items-center md:justify-center lg:flex-col">
                  <div className="lg:mt-[2em] lg:ml-[4em]  lg:mb-[20px] md:w-[434px]">
                    <label htmlFor="Amount" className="lg:block lg:font-sm lg:text-[13px] lg:text-black">
                      Amount
                    </label>
                    <InputComponent
                      placeholder="Amount"
                      name="allocatedBudget"
                      type="text"
                      pattern="[0-9]*"
                      value={addCommasToNumber(formData.allocatedBudget)}
                      handleChange={handleInputChange}
                      className="w-[310px] sm:w-[434px] lg:w-[434px]"
                      error={validationResults.allocatedBudget}
                    />
                  </div>
                  <div className="w-[310px] sm:w-[434px] lg:w-[434px] lg:mt-[21px] lg:mb-6 lg:ml-[4em] mt-[24px]">
                    <label htmlFor="Select Month" className="lg:block lg:font-sm lg:text-[13px] lg:text-black">
                      Select Month
                    </label>
                    <DropdownComponent
                      options={dropDownArray}
                      placeholder="Select Month"
                      selectedValue={selectedValue}
                      setSelectedValue={setSelectedValue}
                      onChange={handleDropDownChange}
                      isSubmitted={isSubmitted}
                      error={validationResults.monthYear}
                      dropdownClassName="w-[310px] sm:w-[434px] lg:w-[434px] lg:bg-white  lg:rounded lg:py-1 lg:focus:ring-0 lg:pointer-events lg:placeholder-gray-400 lg:placeholder-opacity-75"
                      iconClassName="lg:mt-[-4px] lg:mr-[1em] md:mr-[2em]"
                    />
                     {validationResults.monthYear && <div className="text-red-500">{validationResults.monthYear}</div>}
                  </div>
                </div>
                <div className="sm:w-full sm:flex sm:justify-center sm:items-center mt-[32px] sm:mt-[32px] xl:mt-0 lg:w-full lg:h-[48px] lg:flex lg:mt-[69px] lg:justify-start lg:ml-[4em]">
                  <div className="w-[310px] md:w-[434px] lg:w-[434px]">
                    <Button
                      type="submit"
                      text="Save Changes"
                      isLoading={isLoading}
                      disabled={isLoading}
                      onClick={(event) => handleSubmit(event)}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </form>
      {showSuccessModal && (
        <SidebarDrawer
          title={'You’ve successfully set your next monthly budget.'}
          show={showSuccessModal}
          position={'left'}
          buttonText="Continue"
          children={<ProcessSuccessful />}
          onClick={handleContinue}
          showFooter={true}
        />
      )}
    </div>
  );
};